import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		navigationFooter_container: {
			paddingTop: theme.spacing(2),
			display: 'flex',
			borderTop: `1px solid ${theme.palette.grey[400]}`
		},
		navigationFooter_containerAlignLeft: {
			justifyContent: 'flex-start',
		},
		navigationFooter_containerAlignRight: {
			justifyContent: 'flex-end',
		},
		navigationFooter_containerAlignSpaceBetween: {
			justifyContent: 'space-between',
		},
		navigationFooter_buttonWrapperLeft: {
			marginRight: theme.spacing(1),
			[theme.breakpoints.down(BreakpointWidth.MEDIUM)]: {
				minWidth: theme.spacing(16),
			},
			[theme.breakpoints.up(BreakpointWidth.MEDIUM)]: {
				minWidth: theme.spacing(19),
			},
		},
		navigationFooter_buttonWrapperRight: {
			marginLeft: theme.spacing(1),
			[theme.breakpoints.down(BreakpointWidth.MEDIUM)]: {
				minWidth: theme.spacing(16),
			},
			[theme.breakpoints.up(BreakpointWidth.MEDIUM)]: {
				minWidth: theme.spacing(19),
			},
		},
	});
}

export default styles;
